import equal from 'fast-deep-equal'
import { Collection } from './Collection'
import { ListParams, ResourceType } from '../types'

const REGISTRY: Array<[string, any, Collection<any>]> = []

export default function getCollection<K extends ResourceType>(type: K, ...params: ListParams<K>): Collection<K> {
  const existing = REGISTRY.find(([ctype, cparams]) => ctype === type && equal(params, cparams))
  if (existing) {
    return existing[2]
  }

  const collection = new Collection<K>(type, ...params)
  REGISTRY.push([type, params, collection])
  return collection
}
